import { render, staticRenderFns } from "./EventsSection.vue?vue&type=template&id=987862c4&scoped=true"
import script from "./EventsSection.vue?vue&type=script&lang=js"
export * from "./EventsSection.vue?vue&type=script&lang=js"
import style0 from "./EventsSection.vue?vue&type=style&index=0&id=987862c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987862c4",
  null
  
)

export default component.exports